import { LanguageSwitcher } from './LanguageSwitcher';

export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top' onClick={props.onNavClick}>
            <img src='img/logo.png' alt='RecycleMore Logo' style={{ height: '30px', marginRight: '10px', display: 'inline-block', verticalAlign: 'text-bottom' }} />
            {props.data ? props.data.brand : 'RecycleMore'}
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            {props.data ? 
              props.data.items.map((item, index) => (
                <li key={`nav-item-${index}`}>
                  <a href={item.link} className='page-scroll' onClick={props.onNavClick}>
                    {item.name}
                  </a>
                </li>
              ))
            : (
              <>
                <li>
                  <a href='#features' className='page-scroll' onClick={props.onNavClick}>
                    Kellele
                  </a>
                </li>
                <li>
                  <a href='#download' className='page-scroll' onClick={props.onNavClick}>
                    Laadi Alla
                  </a>
                </li>
                <li>
                  <a href='#faq' className='page-scroll' onClick={props.onNavClick}>
                    KKK
                  </a>
                </li>
                <li>
                  <a href='#about' className='page-scroll' onClick={props.onNavClick}>
                    Meist
                  </a>
                </li>
                <li>
                  <a href='#contact' className='page-scroll' onClick={props.onNavClick}>
                    Kontakt
                  </a>
                </li>
              </>
            )}
            <li style={{ marginLeft: '15px', paddingTop: '15px', paddingBottom: '15px' }}>
              <LanguageSwitcher 
                currentLanguage={props.currentLanguage} 
                onLanguageChange={props.onLanguageChange} 
              />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}